import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-centered-dialog',
    templateUrl: './centered-dialog.component.html',
    standalone: false
})
export class CenteredDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public message: string) { }
}
